import { Role } from '@/enums/role';
import { UserInfo } from '@/interfaces/userInfo';

export const isAdvancedModeEnabled = (user?: UserInfo) =>
  user && user.Roles ? user.Roles.includes(Role.ADVANCED_ADMIN) && user.UseAdvancedMode : false;
